import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "headertypes"
    }}>{`HeaderTypes`}</h1>
    <p>{`Indexing sort option header types`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`BASIC_LATIN`}</strong>{` = 1213481548`}</p>
      <p parentName="blockquote">{`Basic Latin`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`FINNISH_SWEDISH`}</strong>{` = 1213485894`}</p>
      <p parentName="blockquote">{`Finnish/Swedish`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`DANISH_NORWEGIAN`}</strong>{` = 1213482062`}</p>
      <p parentName="blockquote">{`Danish/Norwegian`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SPANISH`}</strong>{` = 1213485936`}</p>
      <p parentName="blockquote">{`Spanish`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CROATIAN`}</strong>{` = 1213481842`}</p>
      <p parentName="blockquote">{`Croatian`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CZECH`}</strong>{` = 1213481850`}</p>
      <p parentName="blockquote">{`Czech`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ESTONIAN`}</strong>{` = 1213482355`}</p>
      <p parentName="blockquote">{`Estonian`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`HUNGARIAN`}</strong>{` = 1213483125`}</p>
      <p parentName="blockquote">{`Hungarian`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`LATVIAN`}</strong>{` = 1213484129`}</p>
      <p parentName="blockquote">{`Latvian`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`LITHUANIAN`}</strong>{` = 1213484137`}</p>
      <p parentName="blockquote">{`Lithuanian`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`POLISH`}</strong>{` = 1213485167`}</p>
      <p parentName="blockquote">{`Polish`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ROMANIAN`}</strong>{` = 1213485679`}</p>
      <p parentName="blockquote">{`Romanian`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SLOVAK`}</strong>{` = 1213485931`}</p>
      <p parentName="blockquote">{`Slovak`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SLOVENIAN`}</strong>{` = 1213485934`}</p>
      <p parentName="blockquote">{`Slovenian`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TURKISH`}</strong>{` = 1213486197`}</p>
      <p parentName="blockquote">{`Turkish`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`BELARUSIAN`}</strong>{` = 1213481573`}</p>
      <p parentName="blockquote">{`Belarusian`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`BULGARIAN`}</strong>{` = 1213481589`}</p>
      <p parentName="blockquote">{`Bulgarian`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`RUSSIAN`}</strong>{` = 1213485685`}</p>
      <p parentName="blockquote">{`Russian`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`UKRAINIAN`}</strong>{` = 1213486443`}</p>
      <p parentName="blockquote">{`Ukrainian`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`KOREAN_CONSONANT`}</strong>{` = 1213483887`}</p>
      <p parentName="blockquote">{`Korean Consonant`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`KOREAN_CONSONANT_PLUS_VOWEL`}</strong>{` = 1213483862`}</p>
      <p parentName="blockquote">{`Korean Consonant Plus Vowel`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`HIRAGANA_ALL`}</strong>{` = 1213483073`}</p>
      <p parentName="blockquote">{`Hiragana: A, I, U, E, O...`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`HIRAGANA_CONSONANTS_ONLY`}</strong>{` = 1213483075`}</p>
      <p parentName="blockquote">{`Hiragana: A, Ka, Sa, Ta, Na...`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`KATAKANA_ALL`}</strong>{` = 1213483841`}</p>
      <p parentName="blockquote">{`Katakana: A, I, U, E, O...`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`KATAKANA_CONSONANTS_ONLY`}</strong>{` = 1213483843`}</p>
      <p parentName="blockquote">{`Katakana: A, Ka, Sa, Ta, Na...`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CHINESE_PINYIN`}</strong>{` = 1213481808`}</p>
      <p parentName="blockquote">{`Chinese Pinyin`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CHINESE_STROKE_COUNT`}</strong>{` = 1213481811`}</p>
      <p parentName="blockquote">{`Chinese Stroke Count`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      